import AskTheAuthorInfoContainer from "../../react_components/author/ask_the_author/mobile/ask_the_author_info_container";
import FeaturedAuthorsList from "../../react_components/author/ask_the_author/mobile/featured_authors_list";
import FollowedAuthorsList from "../../react_components/author/ask_the_author/mobile/followed_authors_list";
import AskTheAuthorFeaturedAuthorsStore from "../../react_stores/ask_the_author_featured_authors_store";
import AskTheAuthorFollowedAuthorsStore from "../../react_stores/ask_the_author_followed_authors_store";
import LikeStore from "../../react_stores/like_store";
import CommentsStore from "../../react_stores/comments_store";

export const AskTheAuthorComponents = {
  AskTheAuthorInfoContainer,
  FeaturedAuthorsList,
  FollowedAuthorsList,
};

export const AskTheAuthorStores = {
  AskTheAuthorFeaturedAuthorsStore,
  AskTheAuthorFollowedAuthorsStore,
  LikeStore,
  CommentsStore,
};
